import styled, { css } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';
import { Spin as DefaultSpin } from 'antd';

import { Props } from './Loader';

export const SpinWrapper = styled.div<Props>`
  display: flex;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background-color: ${colors.gray0};

  ${props =>
    props.type === 'start' &&
    css`
      .ant-spin-dot {
        max-width: 4em;
        max-height: 4em;
        width: 30vw;
        height: 30vh;

        .ant-spin-dot-item {
          width: 30px;
          height: 30px;
        }
      }
    `}
`;

export const Spin = styled(DefaultSpin)``;

export const SpinWithBlur = styled(Spin)`
  .ant-spin-blur {
    filter: blur(2px);
  }
`;

export const FullScreenSpin = styled(Spin)`
  &.ant-spin {
    background-color: #fff9;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
`;
